
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { useIsMobile } from "@/hooks/use-mobile"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-success text-primary-foreground hover:bg-success/80",
      },
      size: {
        default: "text-xs",
        sm: "text-[10px] px-2 py-0",
        xs: "text-[8px] px-1.5 py-0",
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
      size?: "default" | "sm" | "xs";
    }

function Badge({ className, variant, size, ...props }: BadgeProps) {
  const isMobile = useIsMobile();
  const badgeSize = isMobile ? "xs" : size || "default";
  
  return (
    <div className={cn(badgeVariants({ variant, size: badgeSize }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
